module.exports = __webpack_public_path__ + "img/sxdl2.7e6aa4f4.svg";